import axios from "@/utils/request"

function GET_LIST(params) {
    return axios.get("/template/ACustomTemplate/index", {
        params: {
            ...params
        }
    })
}

function CHANG_STATUS(params) {
    return axios.post("/template/ACustomTemplate/statusEdit", {
        status: params
    })
}

function LIST_ORDER(params) {
    return axios.post("/template/ACustomTemplate/listOrder", {list_orders: params})
}

function DELE(params) {
    return axios.post("/template/ACustomTemplate/delete", {
        ids: params
    })
}

function ADD_DATA(params) {
    return axios.get("/template/ACustomTemplate/add", {
        params: {}
    })
}

function SUBMIT_ADD(params) {
    return axios.post("/template/ACustomTemplate/addPost", {...params})
}

function SUBMIT_EDIT(params) {
    return axios.post("/template/ACustomTemplate/editPost", {...params})
}

function EDIT_DATA(params) {
    return axios.get("/template/ACustomTemplate/edit", {
        params
    })
}

function GROUP_LIST() {
    return axios.get("/template/ACustomTemplate/group",{
    })
}

//updateGroupData
function SET_GROUP(params) {
    return axios.post("/template/ACustomTemplate/updateGroupData", {
        group:params
    })
}

export default {
    GET_LIST,
    CHANG_STATUS,
    LIST_ORDER,
    DELE,
    ADD_DATA,
    SUBMIT_ADD,
    SUBMIT_EDIT,
    EDIT_DATA,
    GROUP_LIST,
    SET_GROUP
}
